import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-label"
}
const _hoisted_2 = {
  key: 0,
  class: "mt-6 error--text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_input = _resolveComponent("v-date-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.showRequired)
            ? (_openBlock(), _createElementBlock("small", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_date_input, _mergeProps(_ctx.$attrs, {
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _ctx.valueChanged,
      onBlur: _ctx.blur,
      multiple: "range"
    }), null, 16, ["model-value", "onUpdate:modelValue", "onBlur"])
  ]))
}